import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  badge: {
    color: 'white',
    padding: '3px 6px 4px 6px',
    textAlign: 'center',
    borderRadius: '8px',
    margin: '0 4px',
    opacity: 0.7,
  },

  badgeCompleted: {
    extend: 'badge',
    backgroundColor: 'green',
  },

  badgeRunning: {
    extend: 'badge',
    backgroundColor: 'orange',
  },

  badgeCanceled: {
    extend: 'badge',
    backgroundColor: 'grey',
  },

  badgeError: {
    extend: 'badge',
    backgroundColor: 'red',
  },

  fileChooser: {
    display: 'none',
  },

  endOfList: {
    textAlign: 'center',
    padding: '1rem',
    color: '#888',
    fontSize: '0.875rem',
  },

  sortableColumn: {
    display: 'flex',
  },

  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    marginBottom: '8px',
  },
})

export default useStyles
